module.exports = __webpack_public_path__ + "static/img/case_banner_07.818d70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_07.png
// module id = PBos
// module chunks = 34